module.exports = __webpack_public_path__ + "static/media/19_thesun.bae67066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/19_thesun.png
// module id = 82
// module chunks = 0